import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-to-top',
  templateUrl: './to-top.component.html'
})
export class ToTopComponent implements OnInit, OnChanges {

  @Input() scrollToggle: boolean;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.firstChange) {
      this.scroll('header');
    }
  }

  scroll(element) {
    const el = document.getElementById(element);
    el.scrollIntoView({behavior: 'smooth'});
  }

}
